export default {
      id: "ic_menu-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_menu-usage",
      toString: function () {
        return this.url;
      }
    }